const FETCH_STATUSES = {
  idle: 'idle',
  pending: 'pending',
  fulfilled: 'fulfilled',
  failed: 'failed',
};

export default FETCH_STATUSES;
